// Database page: the invoice grid, its toolbar, and the export / import /
// column dialogs. The grid's own chrome (pagination, filter panel, column menu)
// is translated by MUI's German pack, not from here.
//
// Key = the exact English source string used in the code. Value = German.
// Do NOT redefine keys already in common.ts.

export const database: Record<string, string> = {
  'custom columns': 'eigene Spalten',

  // Grid columns
  Due: 'Fällig',
  'Service from': 'Leistung von',
  'Service to': 'Leistung bis',
  Expenses: 'Auslagen',
  'Invoice #': 'Rechnungsnr.',
  'Original invoice': 'Ursprungsrechnung',
  Entity: 'Gesellschaft',
  Approver: 'Freigegeben von',
  'Approved on': 'Freigegeben am',
  'Legal counsel': 'Legal Counsel',
  Created: 'Angelegt',
  'Audit trail': 'Audit Trail',
  'Could not save the row': 'Die Zeile konnte nicht gespeichert werden',

  // Toolbar
  'Search invoice number, supplier, PO …': 'Rechnungsnummer, Lieferant, PO suchen …',
  selected: 'ausgewählt',
  Standard: 'Standard',
  All: 'Alle',
  'Add invoice': 'Rechnung hinzufügen',
  Columns: 'Spalten',

  // Page-level status messages
  'Could not load the data': 'Die Daten konnten nicht geladen werden',
  'Could not load the columns': 'Die Spalten konnten nicht geladen werden',
  'Invoice updated': 'Rechnung aktualisiert',
  'Could not update the invoice': 'Die Rechnung konnte nicht aktualisiert werden',
  '1 invoice updated': '1 Rechnung aktualisiert',
  '{n} invoices updated': '{n} Rechnungen aktualisiert',
  'Bulk update failed': 'Sammeländerung fehlgeschlagen',
  'Invoice deleted': 'Rechnung gelöscht',
  'Could not delete the invoice': 'Die Rechnung konnte nicht gelöscht werden',
  'Invoice created': 'Rechnung angelegt',
  'Could not create the invoice': 'Die Rechnung konnte nicht angelegt werden',
  'Export finished': 'Export abgeschlossen',
  'Export failed': 'Export fehlgeschlagen',
  '{n} invoices imported': '{n} Rechnungen importiert',
  'Import failed': 'Import fehlgeschlagen',
  'Column created': 'Spalte angelegt',
  'Column deleted': 'Spalte gelöscht',

  // ExportDialog
  'Export database': 'Datenbank exportieren',
  'File format': 'Dateiformat',
  'Decimal separator': 'Dezimaltrennzeichen',
  Comma: 'Komma',
  Period: 'Punkt',
  'Include custom columns': 'Eigene Spalten einschließen',

  // ImportDialog
  'Import from Excel': 'Aus Excel importieren',
  'Click to select a file': 'Klicken, um eine Datei auszuwählen',
  'Supported formats:': 'Unterstützte Formate:',
  'Importing will replace all existing data in the database.':
    'Der Import ersetzt alle vorhandenen Daten in der Datenbank.',
  'Please select a valid Excel (.xlsx, .xls) or CSV file':
    'Bitte eine gültige Excel- (.xlsx, .xls) oder CSV-Datei auswählen',

  // ColumnManager
  'Custom columns': 'Eigene Spalten',
  'Add new column': 'Neue Spalte anlegen',
  'Add column': 'Spalte anlegen',
  'Column name': 'Spaltenname',
  'Column name is required': 'Der Spaltenname ist erforderlich',
  'Could not create the column': 'Die Spalte konnte nicht angelegt werden',
  'Could not delete the column': 'Die Spalte konnte nicht gelöscht werden',
  'Configured columns': 'Angelegte Spalten',
  'No custom columns configured yet.': 'Noch keine eigenen Spalten angelegt.',
  Text: 'Text',
  Number: 'Zahl',
}
